import * as types from  '../actions'; 

const initialState = {
  skillRateAllItems: [],
  skillRateItem: [],
  status:0,
  activity:'',  
  clientCrewCheifBonusData:[],
};

export default function(state = initialState, action) {
    const response = action.response; 
    let timeVar = '~~'+Date.now(); 
    switch(action.type) {
        
        case types.CLIENT_RATE_CARD_LIST_SUCCESS:
            if(response.status===200){ 
                return {
                    ...state,
                    skillRateAllItems: response.data,
                    status: response.status,
                    activity: types.CLIENT_RATE_CARD_LIST_SUCCESS+timeVar
                };
            }
            else {
                return {
                    ...state, 
                    status: response.status,
                    activity: types.CLIENT_RATE_CARD_LIST_ERROR+timeVar, 
                    response 
                };   
            }    
        case types.CLIENT_RATE_CARD_LIST_ERROR:
            return {
                ...state, 
                skillRateAllItems: response.data,
                status: response.status,
                activity: types.CLIENT_RATE_CARD_LIST_ERROR+timeVar, 
                response 
            };  
 

        case types.CLIENT_RATE_CARD_UPDATE_SUCCESS:

            if(response.status===200 && response.data.status==='success'){ 
                return {
                    ...state,
                    skillRateItem: response.data, 
                    status: response.data.status,
                    activity: types.CLIENT_RATE_CARD_UPDATE_SUCCESS+timeVar
                };
            }
            else{
                return {
                    ...state, 
                    status: (response && response.status) ? response.status : '',
                    activity: types.CLIENT_RATE_CARD_UPDATE_ERROR+timeVar, 
                    response 
                };   
            }
        case types.CLIENT_RATE_CARD_UPDATE_ERROR:
            return {
                ...state, 
                status: (response && response.status) ? response.status : '',
                activity: types.CLIENT_RATE_CARD_UPDATE_ERROR+timeVar, 
                response 
            };    
        

        case types.CLIENT_GET_CREW_CHIEF_BONUS_SUCCESS:
            if(response.status===200){
                return {
                    ...state,   
                    clientCrewCheifBonusData: response.data,
                    status:response.status,
                    activity:types.CLIENT_GET_CREW_CHIEF_BONUS_SUCCESS+timeVar,
                }     
            }else{
                return {
                    ...state,
                    status:response.status,
                    activity:types.CLIENT_GET_CREW_CHIEF_BONUS_ERROR+timeVar,
                    errorData: response.data,
                }     
            }  
        case types.CLIENT_GET_CREW_CHIEF_BONUS_ERROR:
            return {
                ...state,
                status:response.status,
                activity:types.CLIENT_GET_CREW_CHIEF_BONUS_ERROR+timeVar,
                errorData: response.data,
            } 
        
        
        case types.CLIENT_UPDATE_CREW_CHIEF_BONUS_SUCCESS:
            if(response.status===200){
                return {
                    ...state,   
                    status:response.status,
                    activity:types.CLIENT_UPDATE_CREW_CHIEF_BONUS_SUCCESS+timeVar,
                }     
            }else{
                return {
                    ...state,
                    status:response.status,
                    activity:types.CLIENT_UPDATE_CREW_CHIEF_BONUS_ERROR+timeVar,
                    errorData: response.data,
                }     
            }  
        case types.CLIENT_UPDATE_CREW_CHIEF_BONUS_ERROR:
            return {
                ...state,
                status:response.status,
                activity:types.CLIENT_UPDATE_CREW_CHIEF_BONUS_ERROR+timeVar,
                errorData: response.data,
            } 

        case types.CLEAR:
            return {
                ...state, 
                activity:'',
                status:0               
            }  


        default:
            return state;
  }
};
